import { z } from "zod";

// Request an email change (passport-web /account → POST /auth/email-change/request). Authenticated; the
// current password re-auths the session (guards against a hijacked session taking the account over via an
// attacker-controlled inbox). new_email is the address to move to; users.email is unchanged until confirmed.
export const changeEmailRequestSchema = z.object({
  new_email: z.string().email(),
  password: z.string().min(1),
});
